import PropTypes from "prop-types";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import sprite from "../../assets/icons.svg";

export const QIDatePicker = ({
  label,
  dateFormat,
  date,
  maxDate,
  minDate,
  onChange,
  disabled = false,
  className,
  setShowCalender,
  resetCount,
  singleDatePicker = true,
}) => {
  // Convert date to moment if it's a string or Date object
  const momentDate = date
    ? moment.isMoment(date)
      ? date
      : moment(date)
    : null;

  const dateLabel = momentDate?.format(dateFormat) || "Select Date";

  const handleFocus = () => {
    if (setShowCalender) {
      setShowCalender(true);
    }
  };

  const handleBlur = () => {
    if (setShowCalender) {
      setShowCalender(false);
    }
  };

  const handleReset = () => {
    onChange(null);
    if (setShowCalender) {
      setShowCalender(false);
    }
  };

  return (
    <div className={`qi-input ${disabled && "disabled"} ${className || ""}`}>
      {label && (
        <label className="qi-input_label" data-testid="input-label">
          {label}
        </label>
      )}
      <div className="qi-input_wrapper date-range-picker">
        <DateRangePicker
          key={resetCount}
          initialSettings={{
            singleDatePicker: singleDatePicker,
            timePicker: false,
            startDate: momentDate?.toDate() || moment().toDate(),
            maxDate: maxDate,
            minDate: minDate,
            drops: "auto",
          }}
          onCallback={(start) => onChange(start)}
          onShow={handleFocus}
          onHide={handleBlur}
        >
          <div id="reportrange" className="date-range">
            <span>{dateLabel}</span>

            <span>
              {momentDate && (
                <span className="icon-wrapper clickable" onClick={handleReset}>
                  <svg className={`icon`}>
                    <use href={`${sprite}#cross`}></use>
                  </svg>
                </span>
              )}
            </span>
          </div>
        </DateRangePicker>
      </div>
    </div>
  );
};

QIDatePicker.propTypes = {
  label: PropTypes.string,
  date: PropTypes.instanceOf(moment),
  maxDate: PropTypes.instanceOf(moment),
  minDate: PropTypes.instanceOf(moment),
  onChange: PropTypes.func,
  dateFormat: PropTypes.string,
  singleDatePicker: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  setShowCalender: PropTypes.func,
  resetCount: PropTypes.number,
};

QIDatePicker.defaultProps = {
  label: "",
  maxDate: null,
  minDate: null,
  onChange: () => {},
  dateFormat: "D MMM, YYYY",
  singleDatePicker: true,
  disabled: false,
  className: "",
};
